import React, { useEffect } from 'react';
import { Card, Space, Tag } from 'antd';
import { AlectifyTable } from '../../../../../../components';
import useColumns from './effects/useColumns';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
    getContractorFinancialEstimateDocuments,
    getFinancialEstimationDocumentsMainProject,
} from '../../../../../../store/bidding-management';
import './index.scss';

export default () => {
    const { contractorId } = useParams();
    const dispatch = useDispatch();
    const columns = useColumns();

    const {
        documents: { contractorEstimationDocs },
        fetching,
    } = useSelector(({ bidding }) => bidding);

    useEffect(() => {
        dispatch(
            getContractorFinancialEstimateDocuments(contractorId, {
                page: 1,
                per_page: 10,
            }),
        );
    }, [contractorId]);

    const getDocuments = (pagination) => {
        const params = {
            page: pagination?.page || 1,
            per_page: pagination?.per_page || 10,
        };
        dispatch(getContractorFinancialEstimateDocuments(contractorId, params));
    };

    return (
        <Card
            title={
                <Space>
                    <span>Imported Vendor Documents</span> <Tag color="green">Auto Generated</Tag>
                </Space>
            }
            bordered
        >
            <AlectifyTable
                columns={columns}
                defaultPageSize={10}
                total={contractorEstimationDocs?.meta?.total_count || 0}
                dataSource={contractorEstimationDocs?.data || []}
                loading={fetching}
                onDataFetch={getDocuments}
                selectRows={false}
            />
        </Card>
    );
};
